import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_ws/w/$workspaceId/seats-billing/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/w/$workspaceId/members',
      params: { workspaceId: params.workspaceId },
    })
  },
})
